import {Document, Image, Page, StyleSheet, Font, Text, Link, View} from "@react-pdf/renderer";
import moment from "moment";
import "moment/locale/es";
import { useTranslation } from "react-i18next";

const stylesPdf = StyleSheet.create({
  page: {
    backgroundColor: "white",
    fontFamily: "Futura",
    fontSize: 14,
  },
  titleOne: {
    color: "#1C2E36",
    textAlign: "center",
    marginTop: 12,
    fontSize: 16,
    fontWeight: 700,
    lineHeight: "175%",
  },
  subtitle: {
    color: "#1C2E36",
    textAlign: "center",
    fontSize: 16,
    fontWeight: 400,
  },
  spacetext: {
    marginTop: 8,
    marginBottom: 0,
  },
  spacetextb: {
    marginTop: 8,
    marginBottom: 0,
    fontWeight: 600,
  },
  spacetextxs: {
    marginTop: 4,
    marginBottom: 0,
  },
  step: {
    color: "#1C2E36",
    textAlign: "justify",
    marginTop: 8,
    marginLeft: 24,
    marginRight: 24,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 1.5,
  },
  headerTable: {
    marginTop: 16,
    marginLeft: 24,
    marginRight: 24,
    padding: 8,
    backgroundColor: "#FFB81C",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderColor: "#a5adbb",
    borderTopWidth: 1,
    borderRightWidth: 1,
    borderLeftWidth: 1,
  },
  h1HeaderTable: {
    fontSize: 12,
    fontWeight: 500,
    color: "#1C2E36",
    textAlign: "left",
    lineHeight: "167%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  columnWidth60: {
    width: "60%",
  },
  columnWidth40: {
    width: "40%",
  },
  rowheader: {
    display: "table" as 'flex',
    width: "auto",
    borderWidth: 0,
    marginRight: 8,
    marginLeft: 8,
  },
  rowTable: {
    marginLeft: 24,
    marginRight: 24,
    display: "table" as 'flex',
    width: "auto",
    borderStyle: "solid",
    borderColor: "#a5adbb",
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderBottomRightRadius: 8,
    borderBottomLeftRadius: 8,
  },
  colTable: {
    width: "50%",
    padding: 8,
    backgroundColor: "#ffffff",
    fontSize: 12,
    marginLeft: 0,
    color: "#1C2E36",
    textAlign: "left",
    lineHeight: 1,
    borderStyle: "solid",
    borderColor: "#a5adbb",
    borderTopWidth: 1,
  },
  colTableBottomL: {
    borderBottomLeftRadius: 8,
  },
  colTableBottomR: {
    borderBottomRightRadius: 8,
  },
  colBorderCenter: {
    borderLeftWidth: 1,
    borderColor: "#a5adbb",
  },
  footer: {
    margin: 16,
    fontSize: 9,
    textAlign: "center",
  },
  imagelogoheader: {
    width: 90,
  },
  numberPage: {
    position: "absolute",
    bottom: 24,
    right: 24,
    textAlign: "right",
    color: "#1C2E36",
    fontSize: 10,
  },
  link: {
    color: "#20388f",
  },
  pageBackground: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 0,
  },
  lineText: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
  },
  strongText: {
    fontWeight: 500,
  },
  paddingTextCenter: {
    paddingTop: 6,
  },
  marginT4: {
    marginTop: 4,
  },
});

interface PropsTemplate {
  courses: any[];
  values: {
    orientadores: any[];
    [key: `${any}_date`]: string | any[];
    [key: `${any}__number`]: string | any[];
    directorName: string;
    directorDni: string;
    directorNie: string;
    directorSurname: string;
    directordocumentType: string;
    jefeEmail: string;
    web: string;
    directorEmail: string;
    jefeName: string;
    jefeSurname: string;
    orientadornombre: string;
    orientadorapellidos: string;
    orientadortelef: string;
    orientadoremail: string;
    orientadordocumentType: string;
    orientadordni: string;
    orientadornie: string;
  };
  ccaa: string;
  year: number;
  center: {
    Nombre: string;
    Codigo: string;
    Domicilio: string;
    CodPostal: string;
    Telefono: string;
  };
  user: {
    email:string
  };
}

interface Props {
  props: PropsTemplate
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const MyDocPDFCenterTemplate = (propsA: Props) => {
  const {t} = useTranslation();
  const {props} = propsA;
  const year = props.year;

  return (
    <Document>
    <Page size="A4" style={stylesPdf.page}>
      <Image src={"/assets/img/backgroundpdf.png"} style={stylesPdf.pageBackground} fixed />

      <View style={{flex: 0.1}} fixed>
        <View style={stylesPdf.rowheader}>
          <View style={{flexDirection: "row"}}>
            <View style={{width: "100%", textAlign: "left", marginLeft: 24, marginTop: 24}}>
              <Image style={stylesPdf.imagelogoheader} src={"/assets/img/logo.png"} />
            </View>
            <View style={{flexDirection: "row"}}>
              <View style={{width: 100, textAlign: "right", marginRight: 24, marginTop: 24}}>
                <Image src={"/assets/img/logoblanco.png"} />
              </View>
            </View>
          </View>
        </View>
      </View>
      <View style={{flex: 1}}>
        <View style={stylesPdf.titleOne} fixed>
          <Text>{t("contrato.ficha")}</Text>
        </View>
        <View style={stylesPdf.subtitle} fixed>
          <Text>
            {t("contrato.curso")} {"20" + +year + "/20" + (+year + 1)}
          </Text>
        </View>
        <View style={stylesPdf.step}>
          <Text>
            {t("contrato.step1")}
            <Text style={{fontWeight: 700}}>{props.values.directorName + " " + props.values.directorSurname}</Text>
            <Text>
              {t("contrato.step1b")
                .replace("#directorName#", props.values.directorName + " " + props.values.directorSurname)
                .replace("#centroName#", props.center?.Nombre)
                .replace("#directordocumentType#", props.values.directordocumentType)
                .replace("#directorDNI#", props.values.directordocumentType === 'DNI' ? props.values.directorDni : props.values.directorNie)
                .replace("#yearm#", "20" + +year + "/20" + (+year + 1))}

              <Link style={stylesPdf.link} src={t("contrato.step1linkurl")}>
                {t("contrato.step1link")}
              </Link>
              {t("contrato.step12")}
            </Text>
          </Text>

          <Text style={stylesPdf.spacetext}>{t("contrato.step13")}</Text>
          <Text style={stylesPdf.spacetextxs}>
            {t("contrato.step14")}
            <Link style={stylesPdf.link} src={t("contrato.step14linkurl")}>
              {t("contrato.step14link")}
            </Link>
            {t("contrato.step15")}
          </Text>
        </View>
        <View style={stylesPdf.headerTable} fixed>
          <Text style={stylesPdf.h1HeaderTable}>{t("contrato.datosc")}</Text>
        </View>
        <View style={stylesPdf.rowTable}>
          <View style={{flexDirection: "row"}}>
            <View style={stylesPdf.colTable}>
              <View style={stylesPdf.lineText}>
                <Text style={stylesPdf.strongText}>{t("contrato.centro.title")}: </Text>
                <Text style={stylesPdf.paddingTextCenter}>{props.center?.Nombre}</Text>
              </View>
              <View style={[stylesPdf.lineText, stylesPdf.marginT4]}>
                <Text style={stylesPdf.strongText}>{t("contrato.centro.codigo")}: </Text>
                <Text style={stylesPdf.paddingTextCenter}>{props.center?.Codigo}</Text>
              </View>
              <View style={[stylesPdf.lineText, stylesPdf.marginT4]}>
                <Text style={stylesPdf.strongText}>{t("contrato.centro.web")}: </Text>
                <Text style={stylesPdf.paddingTextCenter}>{props.values.web}</Text>
              </View>
            </View>
            <View style={[stylesPdf.colTable, stylesPdf.colBorderCenter]}>
              <View style={stylesPdf.lineText}>
                <Text style={stylesPdf.strongText}>{t("contrato.centro.address")}: </Text>
                <Text style={stylesPdf.paddingTextCenter}>{props.center?.Domicilio}</Text>
              </View>
              <View style={[stylesPdf.lineText, stylesPdf.marginT4]}>
                <Text style={stylesPdf.strongText}>{t("contrato.centro.cp")}: </Text>
                <Text style={stylesPdf.paddingTextCenter}>{props.center?.CodPostal}</Text>
              </View>
              <View style={[stylesPdf.lineText, stylesPdf.marginT4]}>
                <Text style={stylesPdf.strongText}>{t("contrato.centro.correo-e")}: </Text>
                <Text style={stylesPdf.paddingTextCenter}>{props.user.email}</Text>
              </View>
              <View style={[stylesPdf.lineText, stylesPdf.marginT4]}>
                <Text style={stylesPdf.strongText}>{t("contrato.centro.telf")}: </Text>
                <Text style={stylesPdf.paddingTextCenter}>{props.center?.Telefono}</Text>
              </View>
            </View>
          </View>

          <View style={{flexDirection: "row"}}>
            <View style={stylesPdf.colTable}>
              <Text style={stylesPdf.strongText}>{t("contrato.director")}</Text>
              <View style={[stylesPdf.lineText, stylesPdf.marginT4]}>
                <Text style={stylesPdf.strongText}>{t("contrato.nombre")}: </Text>
                <Text style={stylesPdf.paddingTextCenter}>{props.values.directorName}</Text>
              </View>
              <View style={[stylesPdf.lineText, stylesPdf.marginT4]}>
                <Text style={stylesPdf.strongText}>{t("contrato.apellidos")}: </Text>
                <Text style={stylesPdf.paddingTextCenter}>{props.values.directorSurname}</Text>
              </View>
            </View>
            <View style={[stylesPdf.colTable, stylesPdf.colBorderCenter]}>
              <View style={stylesPdf.lineText}>
                <Text style={stylesPdf.strongText}>
                  {t("contrato.correo-e")} {t("contrato.director").toLowerCase()}:{" "}
                </Text>
                <Text style={stylesPdf.paddingTextCenter}>{props.values.directorEmail}</Text>
              </View>
              <View style={[stylesPdf.lineText, stylesPdf.marginT4]}>
                <Text style={stylesPdf.strongText}>
                {props.values.directordocumentType === 'DNI'
                        ? `${t("registercenter.director.dni")} ${t("contrato.director").toLowerCase()}: `
                        : `${t("registercenter.director.nie")} ${t("contrato.director").toLowerCase()}: `}
                </Text>
                <Text style={stylesPdf.paddingTextCenter}>
                  {props.values.directordocumentType === 'DNI'
                        ? props.values.directorDni ?? '-'
                        : props.values.directorNie ?? '-'
                  }
                </Text>
              </View>
            </View>
          </View>

          <View style={{flexDirection: "row"}}>
            <View style={stylesPdf.colTable}>
              <Text style={stylesPdf.strongText}>{t("contrato.jefe")}</Text>
              <View style={[stylesPdf.lineText, stylesPdf.marginT4]}>
                <Text style={stylesPdf.strongText}>{t("contrato.nombre")}: </Text>
                <Text style={stylesPdf.paddingTextCenter}>{props.values.jefeName}</Text>
              </View>
              <View style={[stylesPdf.lineText, stylesPdf.marginT4]}>
                <Text style={stylesPdf.strongText}>{t("contrato.apellidos")}: </Text>
                <Text style={stylesPdf.paddingTextCenter}>{props.values.jefeSurname}</Text>
              </View>
            </View>
            <View style={[stylesPdf.colTable, stylesPdf.colBorderCenter]}>
              <View style={stylesPdf.lineText}>
                <Text style={stylesPdf.strongText}>
                  {t("contrato.correo-e")} {t("contrato.jefe").toLowerCase()}:{" "}
                </Text>
                <Text style={stylesPdf.paddingTextCenter}>{props.values.jefeEmail}</Text>
              </View>
            </View>
          </View>

          <View style={{flexDirection: "row"}}>
            <View style={[stylesPdf.colTable, stylesPdf.colTableBottomL]}>
              <Text style={stylesPdf.strongText}>{t("contrato.orientador")}_1</Text>
              <View style={[stylesPdf.lineText, stylesPdf.marginT4]}>
                <Text style={stylesPdf.strongText}>{t("contrato.nombre")}: </Text>
                <Text style={stylesPdf.paddingTextCenter}>{props.values.orientadornombre}</Text>
              </View>
              <View style={[stylesPdf.lineText, stylesPdf.marginT4]}>
                <Text style={stylesPdf.strongText}>{t("contrato.apellidos")}: </Text>
                <Text style={stylesPdf.paddingTextCenter}>{props.values.orientadorapellidos}</Text>
              </View>
              <View style={[stylesPdf.lineText, stylesPdf.marginT4]}>
                <Text style={stylesPdf.strongText}>{t("contrato.centro.telf")}: </Text>
                <Text style={stylesPdf.paddingTextCenter}>{props.values.orientadortelef}</Text>
              </View>
            </View>
            <View style={[stylesPdf.colTable, stylesPdf.colTableBottomR, stylesPdf.colBorderCenter]}>
              <View style={stylesPdf.lineText}>
                <Text style={stylesPdf.strongText}>
                  {t("contrato.correo-e")} {t("contrato.orientador").toLowerCase()}_1:{" "}
                </Text>
                <Text style={stylesPdf.paddingTextCenter}>{props.values.orientadoremail}</Text>
              </View>
              <View style={[stylesPdf.lineText, stylesPdf.marginT4]}>
                <Text style={stylesPdf.strongText}>
                      {props.values.orientadordocumentType === 'DNI'
                        ? `${t("registercenter.orientador.dni")} ${t("contrato.orientador").toLowerCase()}: `
                        : `${t("registercenter.orientador.nie")} ${t("contrato.orientador").toLowerCase()}: `}
                </Text>
                <Text style={stylesPdf.paddingTextCenter}>
                  {props.values.orientadordocumentType === 'DNI'
                        ? props.values.orientadordni ?? '-'
                        : props.values.orientadornie ?? '-'
                  }
                  </Text>
              </View>
            </View>
          </View>
          {props.values.orientadores &&
            props.values.orientadores.map((orientador, index) => (
              <View style={{flexDirection: "row"}}>
                <View style={[stylesPdf.colTable, stylesPdf.colTableBottomL]}>
                  <Text style={stylesPdf.strongText}>
                    {t("contrato.orientador")}_{index + 2}
                  </Text>
                  <View style={[stylesPdf.lineText, stylesPdf.marginT4]}>
                    <Text style={stylesPdf.strongText}>{t("contrato.nombre")}: </Text>
                    <Text style={stylesPdf.paddingTextCenter}>{orientador.nombre}</Text>
                  </View>
                  <View style={[stylesPdf.lineText, stylesPdf.marginT4]}>
                    <Text style={stylesPdf.strongText}>{t("contrato.apellidos")}: </Text>
                    <Text style={stylesPdf.paddingTextCenter}>{orientador.apellidos}</Text>
                  </View>
                  <View style={[stylesPdf.lineText, stylesPdf.marginT4]}>
                    <Text style={stylesPdf.strongText}>{t("contrato.centro.telf")}: </Text>
                    <Text style={stylesPdf.paddingTextCenter}>{orientador.telef}</Text>
                  </View>
                </View>
                <View style={[stylesPdf.colTable, stylesPdf.colTableBottomR, stylesPdf.colBorderCenter]}>
                  <View style={stylesPdf.lineText}>
                    <Text style={stylesPdf.strongText}>
                      {t("contrato.correo-e")} {t("contrato.orientador").toLowerCase()}_{index + 2}:{" "}
                    </Text>
                    <Text style={stylesPdf.paddingTextCenter}>{orientador.email}</Text>
                  </View>
                  <View style={[stylesPdf.lineText, stylesPdf.marginT4]}>
                    <Text style={stylesPdf.strongText}>
                      {orientador.documentType === 'DNI'
                        ? `${t("registercenter.orientador.dni")} ${t("contrato.orientador").toLowerCase()}_${index + 2}: `
                        : `${t("registercenter.orientador.nie")} ${t("contrato.orientador").toLowerCase()}_${index + 2}: `}
                    </Text>
                    <Text style={stylesPdf.paddingTextCenter}>
                      {orientador.documentType === 'DNI'
                        ? orientador.dni ?? '-'
                        : orientador.nie ?? '-'}
                    </Text>
                  </View>
                </View>
              </View>
            ))}
        </View>
      </View>
      <View fixed style={stylesPdf.footer}>
        <Text>{t("contrato.footer")}</Text>
        <Text>{t("contrato.subfooter")}</Text>
      </View>
      <Text style={stylesPdf.numberPage} render={({pageNumber}) => `${pageNumber}`} fixed />
    </Page>
    <Page size="A4" style={stylesPdf.page}>
      <Image src={"/assets/img/backgroundpdf.png"} style={stylesPdf.pageBackground} />
      <View style={{flex: 0.1}}>
        <View style={stylesPdf.rowheader}>
          <View style={{flexDirection: "row"}}>
            <View style={{width: "100%", textAlign: "left", marginLeft: 24, marginTop: 24}}>
              <Image style={stylesPdf.imagelogoheader} src={"/assets/img/logo.png"} />
            </View>
            <View style={{flexDirection: "row"}}>
              <View style={{width: 100, textAlign: "right", marginRight: 24, marginTop: 24}}>
                <Image src={"/assets/img/logoblanco.png"} />
              </View>
            </View>
          </View>
        </View>
      </View>
      <View style={{flex: 1}}>
        <View style={stylesPdf.titleOne}>
          <Text>{t("contrato.ficha")}</Text>
        </View>
        {/* TODO Fehca */}
        <View style={stylesPdf.subtitle}>
          <Text>
            {t("contrato.curso")} {"20" + +year + "/20" + (+year + 1)}
          </Text>
        </View>
        <View style={stylesPdf.step}>
          <Text style={stylesPdf.spacetext}>{t("contrato.receiveinfo")}</Text>
          <Text style={stylesPdf.spacetext}>
            {t("contrato.step3").replace("#yearm#", "20" + +year + "/20" + (+year + 1))}
          </Text>
          <Text style={stylesPdf.spacetextxs}>
            {t("contrato.step4")}
            <Link style={stylesPdf.link} src={t("contrato.step4linkurl")}>
              {t("contrato.step4link")}
            </Link>
          </Text>
        </View>
        <View style={stylesPdf.headerTable}>
          <View style={{flexDirection: "row"}}>
            <View style={[stylesPdf.h1HeaderTable, stylesPdf.columnWidth60]}>
              <Text>{t("contrato.datosa")}</Text>
            </View>
            <View style={[stylesPdf.h1HeaderTable, stylesPdf.columnWidth40, {paddingLeft: 8}]}>
              <Text>{t("contrato.fechas")}</Text>
            </View>
          </View>
        </View>
        <View style={stylesPdf.rowTable}>
          {props.courses.map((course, index) => {
            return (
              props.values[(course.id + "_number") as any] && (
                <View style={{flexDirection: "row"}}>
                  <View style={[stylesPdf.colTable, stylesPdf.colTableBottomL, stylesPdf.columnWidth60]}>
                    <View style={stylesPdf.lineText}>
                      <Text style={stylesPdf.strongText}>
                        {t("contrato.numAlumnos")} {course.name}:{" "}
                      </Text>
                      <Text style={stylesPdf.paddingTextCenter}>
                        {props.values[(course.id + "_number") as any] ? props.values[(course.id + "_number") as any] : ""}
                      </Text>
                    </View>
                  </View>
                  <View
                    style={[
                      stylesPdf.colTable,
                      stylesPdf.colBorderCenter,
                      stylesPdf.colTableBottomR,
                      stylesPdf.columnWidth40,
                    ]}
                  >
                    <View style={stylesPdf.lineText}>
                      <Text style={stylesPdf.paddingTextCenter}>
                        {props.values[(course.id + "_date") as any]
                          ? moment(props.values[(course.id + "_date") as any]).format("DD/MM/YYYY")
                          : ""}
                      </Text>
                    </View>
                  </View>
                </View>
              )
            );
          })}
        </View>
      </View>
      <View fixed style={stylesPdf.footer}>
        <Text>{t("contrato.footer")}</Text>
        <Text>{t("contrato.subfooter")}</Text>
      </View>
      <Text style={stylesPdf.numberPage} render={({pageNumber}) => `${pageNumber}`} fixed />
    </Page>
    <Page wrap size="A4" style={stylesPdf.page}>
      <Image src={"/assets/img/backgroundpdf.png"} style={stylesPdf.pageBackground} />
      <View style={{flex: 0.1}}>
        <View style={stylesPdf.rowheader}>
          <View style={{flexDirection: "row"}}>
            <View style={{width: "100%", textAlign: "left", marginLeft: 24, marginTop: 24}}>
              <Image style={stylesPdf.imagelogoheader} src={"/assets/img/logo.png"} />
            </View>
            <View style={{flexDirection: "row"}}>
              <View style={{width: 100, textAlign: "right", marginRight: 24, marginTop: 24}}>
                <Image src={"/assets/img/logoblanco.png"} />
              </View>
            </View>
          </View>
        </View>
      </View>
      <View style={{flex: 1}}>
        <View style={stylesPdf.titleOne}>
          <Text>{t("contrato.ficha")}</Text>
        </View>
        {/* TODO Fehca */}
        <View style={stylesPdf.subtitle}>
          <Text>
            {t("contrato.curso")} {"20" + +year + "/20" + (+year + 1)}
          </Text>
        </View>

        <View style={stylesPdf.step}>
          <Text>
            {t("contrato.ffecha")
              .replace("#comunidadAutonoma#", props.ccaa)
              .replace("#dia#", moment().format("D"))
              .replace("#mes#", moment().format("MMMM"))
              .replace("#ano#", moment().format("YYYY"))}
          </Text>

          <Text style={{marginTop: 50}}>{props.values.directorName + " " + props.values.directorSurname}</Text>
          <Text style={{marginTop: 20}}>{t("contrato.sello")}</Text>
        </View>
        <View
          style={{
            marginTop: 200,
          }}
        >
          <View
            style={{
              backgroundColor: "#FFFBE6",
              fontSize: 12,
              width: 500,
              fontWeight: 400,
              margin: "auto",
              padding: 16,
              color: "#1C2E36",
            }}
          >
            <View style={{width: "100%", display: "flex", flexDirection: "row"}}>
              <Image style={{marginRight: 24, width: 16, height: 16}} src={"/assets/img/ExclamationCircle.png"} />
              <Text style={{fontWeight: 700, fontSize: 16}}>{t("contrato.recuerde")}</Text>
            </View>
            <View style={{display: "flex", flexDirection: "row", marginLeft: 40, marginTop: 8}}>
              <Text style={{fontWeight: 400, fontSize: 14}}>1.</Text>
              <Text
                style={{
                  fontWeight: 400,
                  fontSize: 14,
                  marginLeft: 8,
                  marginRight: 8,
                }}
              >
                {t("contrato.recuerde1")}
              </Text>
            </View>
            <View style={{display: "flex", flexDirection: "row", marginLeft: 40, marginTop: 4}}>
              <Text style={{fontWeight: 400, fontSize: 14}}>2.</Text>
              <Text
                style={{
                  fontWeight: 400,
                  fontSize: 14,
                  marginLeft: 8,
                  marginRight: 8,
                }}
              >
                {t("contrato.recuerde2")}
              </Text>
            </View>
          </View>
        </View>
      </View>
      <View fixed style={stylesPdf.footer}>
        <Text>{t("contrato.footer")}</Text>
        <Text>{t("contrato.subfooter")}</Text>
      </View>
      <Text style={stylesPdf.numberPage} render={({pageNumber}) => `${pageNumber}`} fixed />
    </Page>
  </Document>
)};
